import BaseService from './base/base.service'

export default class SubscriptionService extends BaseService {

    constructor(){
        super('subscription')
    }
}